<template>
  <DashboardWidgetGauge class="widget-indice-indipendenza-terzi" :loading="loading" title="Indice di Indipendenza da terzi" :min="min" :max="max" :value="value" />
</template>

<script>

export default {
  name: 'dashboard-widget-indice-indipendenza-terzi',
  components: {
    DashboardWidgetGauge: () => import('../BaseWidgets/DashboardWidgetGauge'),
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 3,
    },
    value: {
      type: Number,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>
